// extracted by mini-css-extract-plugin
module.exports = {"table-data-cell-border-bottom":"styles-module__table-data-cell-border-bottom___2XgAV","avg-trend-cell":"styles-module__avg-trend-cell___3W_k7"};